import { Link } from "react-router-dom";

const NetworkModal = () => {
  return (
    <div className="relative flex flex-col justify-start items-center top-[40px] right-[40px] w-[243.5px] h-[192px] text-center text-xs">
      <div className="absolute top-[10px] left-[0px] rounded-mini bg-white shadow-[-10.383894920349121px_-8.495914459228516px_28.32px_rgba(0,_0,_0,_0.35),_12.271876335144043px_11.327885627746582px_28.32px_rgba(0,_0,_0,_0.35)] [backdrop-filter:blur(240.72px)] w-[243.5px] h-[192px]" />
      <img
        className="absolute top-[1px] w-[13px] h-[10px]"
        alt=""
        src="/arrow.svg"
      />
      <div className="z-0 mt-[23px] font-semibold text-yellowgreen w-[135.03px] h-[24.05px]">
        Network and Volume
      </div>
      <img
        className="z-0 mt-[5px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator.svg"
      />
      <div className="z-0 mt-[15px] text-[10px] mx-3 w-[210px] text-center ">
        Right next to the sign-in button is the notifications bar. Here, the
        network icon displays connectivity strength or hotspot status and the
        volume bar icon displays sound levels.
      </div>
      <img
        className="z-0 mt-[20px] w-[245.5px] h-0.25"
        alt=""
        src="/seprator1.svg"
      />
      <div className="absolute h-[24px] w-[64.18%] top-[88%]">
        <Link to="/useraccounts" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[52.15%] bottom-[0%] left-[0%]">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-mini bg-lightsteelblue" />
            <div className="absolute text-darkslategray text-[9px] w-full top-[23.33%] left-[0%] inline-block">
              Previous
            </div>
          </div>
        </Link>
        <Link to="/screenshare" className="decoration-transparent">
          <div className="absolute h-full w-[47.85%] top-[0%] right-[0%] bottom-[0%] left-[52.15%] text-white">
            <div className="absolute h-full w-full top-[0%] right-[0%] bottom-[0%] left-[0%] rounded-[25px] bg-yellowgreen" />
            <div className="absolute text-[9px] w-full top-[20%] left-[0%] inline-block">
              Continue
            </div>
          </div>
        </Link>
      </div>
      <Link to="/home" className="decoration-transparent">
        <img
          className="absolute h-[13px] w-[13px] top-[9%] right-[4%] bottom-[85.6%] left-[91.44%] max-w-full overflow-hidden max-h-full"
          alt=""
          src="/close.svg"
        />
      </Link>
    </div>
  );
};

export default NetworkModal;
